export default __webpack_public_path__ + "static/media/articlesWithBookmarks.d6a1e0ea.png";